export interface DataOfPnUcs {
    Pan: "",
    Ucc: "",
    ClientId: "",
    Isvalid: boolean
}

// Define the class instead of interface
export class DataOfPnUc {
    Pan: string;
    Ucc: string;
    ClientId: string;
    Isvalid: boolean; // to check whather selected Pan and clientId exists, crucial when toggling between check boxes

    constructor() {
        // Set default values in the constructor
        this.Pan = "";
        this.Ucc = "";
        this.ClientId = "";
        this.Isvalid = false;
    }
}
